import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetMaintenanceWorkStatus } from './maintenance-work.actions';

export interface MaintenanceWorkStateModel {
  maintenanceActive: boolean;
  statusMessage: string | undefined;
}

const DEFAULT_STATE: MaintenanceWorkStateModel = {
  maintenanceActive: false,
  statusMessage: undefined,
};

@State<MaintenanceWorkStateModel>({
  name: 'maintenanceWork',
  defaults: DEFAULT_STATE,
})
@Injectable()
export class MaintenanceWorkStateModule {
  @Selector()
  public static maintenanceActive(state: MaintenanceWorkStateModel): boolean {
    return state.maintenanceActive;
  }

  @Selector()
  public static statusMessage(state: MaintenanceWorkStateModel): string {
    return state.statusMessage;
  }

  @Action(SetMaintenanceWorkStatus)
  public setMaintenanceWorkStatus(ctx: StateContext<MaintenanceWorkStateModel>, { payload }: SetMaintenanceWorkStatus) {
    const { maintenanceActive, statusMessage } = payload;
    return ctx.patchState({ maintenanceActive, statusMessage });
  }
}
